import axios from 'axios';
import multiDownload from 'multi-download';

class DownloadHelper {
  static downloadFile(path) {
    const url = window.location.origin + '/' + path;
    return axios.head(url).then(() => { multiDownload([url]); });
  }
}

export default DownloadHelper;


// WEBPACK FOOTER //
// ./src/utils/DownloadHelper.js